<template>
  <div class="settings-devices">
    <div class="media-device ma-2">
      <media-device />
    </div>
  </div>
</template>

<script>
import MediaDevice from '@/components/settings/media'

export default {
  name: 'settings-devices',
  components: {
    MediaDevice
  }
}
</script>

<style></style>
